import { LinearProgress, Tooltip } from "@material-ui/core";
import axios from "axios";
import Moment from "moment";
import React, { Component } from "react";
import { Card, Modal, Alert, Table, Button, Form } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { NavLink } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { NoticeInformasi, YearSelect } from "../../../_metronic/_partials/controls";
import AppConfig from "../../config/AppConfig";

import swal from "sweetalert";

const bgImage = toAbsoluteUrl("/media/misc/bg-1.jpg");
const bgImage2 = toAbsoluteUrl("/media/bg/bg-9.jpg");

class ManajemenPenjaminanMutu extends Component {
  constructor(props, context) {
    super(props, context);
    this.modalDetail = this.modalDetail.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseSurvei = this.handleCloseSurvei.bind(this);
    this.submitSurvei = this.submitSurvei.bind(this);
    this.lihatSurvei = this.lihatSurvei.bind(this);
    this.deleteSurvei = this.deleteSurvei.bind(this);
  }
  state = {
    sessiondata: JSON.parse(localStorage.getItem("sessiondata")),
    userdata: JSON.parse(localStorage.getItem("userdata")),
    dashboard: "",
    evaluasi: "",
    pelaksanaan: "",
    penetapan: "",
    pengendalian: "",
    peningkatan: "",
    locked: false,
    // information data(s)
    keyword: "",
    limit: 4,
    start: 0,
    loadingList: true,
    data_konten: [],
    data_foto: [],
    data_lampiran: [],
    totalData: 0,
    totalPaginationNumber: 0,
    showFrom: 0,
    modalDetail: false,
    loadingDetails: true,
    detail_informasi: [],
    detail_cover: null,
    file: "",
    nm_file: "",
    // survei
    showSurvei: false,
    pernyataan: [],
    hasil_survei: [],
    id_survei_kepuasan_saran: "",
    saran: "",
    loadingSaveSurvei: false,
    btn_hapus: false,
    info_survei: false,
    survei_disable: false,
    selectedYear: localStorage.getItem("tahun_siklus")
      ? parseInt(localStorage.getItem("tahun_siklus"))
      : new Date().getFullYear(),
    penetapan_sudah_terisi: 0,
    evaluasi_sudah_terisi: 0,
    pengendalian_sudah_terisi: 0,
    peningkatan_sudah_terisi: 0,
  };

  handleTahunSiklusChanged = (e) => {
    const year = e.detail ? e.detail.year : parseInt(localStorage.getItem("tahun_siklus"), 10);
    this.setState({ selectedYear: year });
    this.getStatusDashboard(year);
  };

  handleStorageChange = (e) => {
    if (e.key === "tahun_siklus" && e.newValue) {
      const year = parseInt(e.newValue, 10);
      this.setState({ selectedYear: year });
      this.getStatusDashboard(year);
    }
  };

  componentDidMount() {
    if (!localStorage.getItem("tahun_siklus")) {
      localStorage.setItem("tahun_siklus", new Date().getFullYear());
    }
    this.getStatusDashboard();
    this.getinformations();
    this.getSurveiKepuasan();
    window.addEventListener("tahunSiklusChanged", this.handleTahunSiklusChanged);
    window.addEventListener("storage", this.handleStorageChange);
  }

  componentWillUnmount() {
    window.removeEventListener("tahunSiklusChanged", this.handleTahunSiklusChanged);
    window.removeEventListener("storage", this.handleStorageChange);
  }

  getStatusDashboard(datep) {
    let id_sp = this.state.sessiondata.i_idunit;
    this.setState({
      locked: this.state.sessiondata.is_locked,
    });

    let year = this.state.selectedYear

    if (datep) {
      year = datep
    }

    axios
      .get(AppConfig.GetStatusDashboard + id_sp + "/" + year)
      .then((res) => {
        this.setState({
          dashboard: res.data.result.dashboard,
          evaluasi: res.data.result.evaluasi,
          pelaksanaan: res.data.result.pelaksanaan,
          penetapan: res.data.result.penetapan,
          penetapan_sudah_terisi: res.data.result.penetapan_sudah_terisi,
          evaluasi_sudah_terisi: res.data.result.evaluasi_sudah_terisi,
          pengendalian: res.data.result.pengendalian,
          pengendalian_sudah_terisi: res.data.result.pengendalian_sudah_terisi,
          peningkatan: res.data.result.peningkatan,
          peningkatan_sudah_terisi: res.data.result.peningkatan_sudah_terisi,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getinformations() {
    this.setState({ loadingList: true });

    var formData = new FormData();
    formData.append("data[keyword]", this.state.keyword);
    formData.append("data[id_viewer]", this.state.sessiondata.i_idrole);
    formData.append("data[id_pembina]", this.state.sessiondata.i_idunit);
    axios
      .post(
        AppConfig.ListKonten +
        "?limit=" +
        this.state.limit +
        "&start=" +
        this.state.start,
        formData
      )
      .then((res) => {
        console.log(res.data.result);
        this.setState(
          {
            loadingList: false,
            data_konten: res.data.result.data,
            data_foto: res.data.result.pict_cover,
            totalData: res.data.result.total_rows,
            totalPaginationNumber: Math.ceil(
              res.data.result.total_rows / this.state.limit
            ),
            showFrom: (this.state.currentPage - 1) * this.state.limit + 1,
          },
          () => {
            // console.log(this.state.getUsers);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onChangeSurvei = (e) => {
    let change_survei = this.state.pernyataan.map((val) => {
      if (val.id_pernyataan === e.target.name) {
        val.tingkat_kepuasan = parseInt(e.target.value);
      }
      return val;
    });
    this.setState({ pernyataan: change_survei });
  };

  lihatSurvei() {
    this.setState({
      showSurvei: true,
    });
  }

  onChangeVal = (e, type) => {
    this.setState({
      [type]: e.target.value,
      counter: e.target.value.length,
    });
  };

  getSurveiKepuasan() {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    this.setState({ loadingList: true });

    var formData = new FormData();
    formData.append("data[id_role]", sessiondata.i_idrole);
    formData.append("data[id_sp]", sessiondata.i_idunit);
    formData.append("data[id_pengguna]", sessiondata.i_iduser);
    axios
      .post(AppConfig.DataSurveiKepuasan + session, formData)
      .then((res) => {
        let data_pernyataan = [];
        let jum_jawaban = 0;
        let survei_disable = false;
        for (let i = 0; i < res.data?.result?.pernyataan?.length; i++) {
          const val = res.data?.result?.pernyataan[i];
          let tingkat_kepuasan = "";
          let id_survei_kepuasan = "";
          if (res.data?.result?.hasil_survei[val.id_pernyataan] !== undefined) {
            tingkat_kepuasan =
              res.data?.result?.hasil_survei[val.id_pernyataan]?.tingkat_kepuasan;
            id_survei_kepuasan =
              res.data?.result?.hasil_survei[val.id_pernyataan]
                .id_survei_kepuasan;
            if (
              res.data?.result?.hasil_survei[val.id_pernyataan]
                .tingkat_kepuasan !== "null"
            ) {
              jum_jawaban += 1;
            }
            if (
              res.data?.result?.hasil_survei[val.id_pernyataan]?.id_pengguna !=
              userdata.id_pengguna
            ) {
              survei_disable = true;
            }
          }

          if (res.data?.result.hasil_survei["null"] !== undefined) {
            this.setState({
              id_survei_kepuasan_saran:
                res.data?.result?.hasil_survei["null"]?.id_survei_kepuasan,
              saran: res.data?.result?.hasil_survei["null"]?.saran,
            });
          }

          let data_p = {
            id_pernyataan: val.id_pernyataan,
            pernyataan: val.pernyataan,
            tingkat_kepuasan: tingkat_kepuasan,
            id_survei_kepuasan: id_survei_kepuasan,
            saran: "",
          };
          data_pernyataan.push(data_p);
        }

        let statusSurvei = false;
        if (
          res.data?.result?.pernyataan?.length > 0 &&
          jum_jawaban < res.data?.result?.pernyataan?.length
        ) {
          statusSurvei = true;
        } else {
          if (res.data?.result?.pernyataan?.length > 0) {
            this.setState({
              info_survei: true,
            });
          }
        }

        let statusBtnHapus = false;
        if (Object.keys(res.data?.result?.hasil_survei).length > 0) {
          statusBtnHapus = true;
        }
        this.setState({
          showSurvei: statusSurvei,
          pernyataan: data_pernyataan,
          btn_hapus: statusBtnHapus,
          survei_disable: survei_disable,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  submitSurvei() {
    this.setState({ loadingSaveSurvei: true });

    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    let pernyataan_save = [];
    for (let i = 0; i < this.state.pernyataan.length; i++) {
      const val = this.state.pernyataan[i];

      let data_p = {
        id_pernyataan: val.id_pernyataan,
        pernyataan: val.pernyataan,
        tingkat_kepuasan: val.tingkat_kepuasan.toString(),
        id_survei_kepuasan: val.id_survei_kepuasan,
        saran: val.saran,
      };

      pernyataan_save.push(data_p);
    }
    if (this.state.saran !== "") {
      let data_p = {
        id_pernyataan: "",
        pernyataan: "",
        tingkat_kepuasan: "",
        id_survei_kepuasan: this.state.id_survei_kepuasan_saran,
        saran: this.state.saran,
      };
      pernyataan_save.push(data_p);
    }

    var formData = new FormData();
    formData.append("data[id_role]", sessiondata.i_idrole);
    formData.append("data[id_sp]", sessiondata.i_idunit);
    formData.append("data[id_pengguna]", sessiondata.i_iduser);
    formData.append("data[data_survei]", JSON.stringify(pernyataan_save));

    console.log("formData", formData);
    axios
      .post(AppConfig.SaveDataSurveiKepuasan + session, formData)
      .then((res) => {
        this.setState({
          loadingSaveSurvei: false,
        });
        if (res.data.status === "sukses") {
          swal({
            title: "Berhasil!",
            text: "Simpan survei kepuasan pengguna berhasil!",
            icon: "success",
            button: "OK!",
          });
          this.componentDidMount();
        } else {
          swal({
            title: "Gagal!",
            text: "Simpan survei kepuasan pengguna gagal!",
            icon: "error",
            button: "OK!",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  deleteSurvei() {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    swal({
      title: "Apakah anda yakin?",
      text: "Data akan terhapus dan tidak tercatat pada historical",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loadingSaveSurvei: true });

        var formData = new FormData();
        formData.append("data[id_role]", sessiondata.i_idrole);
        formData.append("data[id_sp]", sessiondata.i_idunit);
        formData.append("data[id_pengguna]", sessiondata.i_iduser);

        axios
          .post(AppConfig.DeleteDataSurveiKepuasan + session, formData)
          .then((res) => {
            this.setState({
              loadingSaveSurvei: false,
            });
            if (res.data.status === "sukses") {
              this.setState({
                btn_hapus: false,
                info_survei: false,
                saran: "",
                id_survei_kepuasan_saran: "",
              });
              swal({
                title: "Berhasil!",
                text: "Hapus survei kepuasan pengguna berhasil!",
                icon: "success",
                button: "OK!",
              });
              this.componentDidMount();
            } else {
              swal({
                title: "Gagal!",
                text: "Hapus survei kepuasan pengguna gagal!",
                icon: "error",
                button: "OK!",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  }

  modalDetail(id, cover) {
    this.setState({ modalDetail: true, loadingDetails: true, detail_cover: cover });
    axios
      .get(AppConfig.EditInformasi + id)
      .then((res) => {
        this.setState({
          loadingDetails: false,
          detail_informasi: {
            judul: res.data.result.data_konten.judul,
            isi_konten: res.data.result.data_konten.isi_konten,
          },
          file: res.data.result.data_lampiran?.konten_dokumen,
          nm_file: res.data.result.data_lampiran?.filename,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleClose() {
    this.setState({
      modalDetail: false,
      detail_cover: null,
    });
  }

  handleCloseSurvei() {
    this.setState({
      showSurvei: false,
    });
  }

  downloadPDF(file) {
    const linkSource = `data:application/pdf;base64,${file}`;
    const downloadLink = document.createElement("a");
    const fileName = this.state.nm_file;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  render() {
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));
    let id_pembina = this.state.sessiondata.i_idunit;
    let arrOfKonten = [];
    let coverPict = [];
    for (let i = 0; i < this.state.data_konten.length; i++) {
      const el = this.state.data_konten[i];
      if (el.id_role_updater === 10) {
        arrOfKonten.push(el);
        coverPict.push(this.state.data_foto[i]);
      }
      if (el.id_role_updater === 2014) {
        if (el.id_pembina === id_pembina) {
          arrOfKonten.push(el);
          coverPict.push(this.state.data_foto[i]);
        }
      }
    }
    console.log(coverPict);

    var kosong = (
      <Tooltip title="Kosong" placement="top-end">
        <span className="d-block text-right">
          <div
            className="btn btn-icon btn-clean btn-lg mr-1 pulse pulse-warning"
            style={{ position: "absolute", right: "20px" }}
          >
            <span className="svg-icon svg-icon-xl svg-icon-danger">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Warning-2.svg")} />
            </span>

            <span className="pulse-ring"></span>
          </div>
        </span>
      </Tooltip>
    );
    let sudah_melengkapi = (
      <Tooltip title="Sudah Melengkapi" placement="top-end">
        <span className="d-block text-right">
          <div
            className="btn btn-icon btn-clean btn-lg mr-1 pulse pulse-success"
            style={{ position: "absolute", right: "20px" }}
          >
            <span className="svg-icon svg-icon-xl svg-icon-success">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Code/Done-circle.svg")}
              />
            </span>
            <span className="pulse-ring"></span>
          </div>
        </span>
      </Tooltip>
    );
    var belum_lengkap = (
      <Tooltip title="Belum Lengkap" placement="top-end">
        <span className="d-block text-right">
          <div
            className="btn btn-icon btn-clean btn-lg mr-1 pulse pulse-warning"
            style={{ position: "absolute", right: "20px" }}
          >
            <span className="svg-icon svg-icon-xl svg-icon-warning">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Warning-2.svg")} />
            </span>
            <span className="pulse-ring"></span>
          </div>
        </span>
      </Tooltip>
    );

    let info_vokasi = "";
    if (userdata.i_idbp === 2) {
      info_vokasi = (
        <Alert variant="info">
          <b>
            Buku Panduan Pelaporan Sistem Penjaminan Mutu Internal Perguruan
            Tinggi Vokasi 2023
          </b>
          <br />
          <br />
          <a
            href="https://s.id/BukuPanduanPengisianPelaporanSPMI"
            target="_blank"
            className="btn btn-icon btn-sm btn-primary btn-hover-light mr-2 my-1"
            style={{ width: "200px" }}
          >
            <i className="flaticon-download icon-xs mr-2" /> Download Buku
            Panduan
          </a>
          <a
            href={toAbsoluteUrl(
              "/media/file/1207_Surat Pemberitahuan Verifikasi Pelaporan SPMI PT (Periode 2).pdf"
            )}
            target="_blank"
            className="btn btn-icon btn-sm btn-success btn-hover-light mr-2 my-1"
            style={{ width: "250px" }}
          >
            <i className="flaticon-download icon-xs mr-2" /> Download Surat
            Pemberitahuan
          </a>
        </Alert>
      );
    }

    let data_survei = [];
    let body_btn_hapus = "";
    if (this.state.showSurvei === true) {
      this.state.pernyataan.map((list, i) => {
        data_survei.push(
          <tr>
            <td>{list.pernyataan}</td>
            <td style={{ textAlign: "center" }}>
              <input
                type="radio"
                name={list.id_pernyataan}
                disabled={this.state.survei_disable}
                value="1"
                onChange={this.onChangeSurvei}
                checked={list.tingkat_kepuasan === 1}
              />
            </td>
            <td style={{ textAlign: "center" }}>
              <input
                type="radio"
                name={list.id_pernyataan}
                disabled={this.state.survei_disable}
                value="2"
                onChange={this.onChangeSurvei}
                checked={list.tingkat_kepuasan === 2}
              />
            </td>
            <td style={{ textAlign: "center" }}>
              <input
                type="radio"
                name={list.id_pernyataan}
                disabled={this.state.survei_disable}
                value="3"
                onChange={this.onChangeSurvei}
                checked={list.tingkat_kepuasan === 3}
              />
            </td>
            <td style={{ textAlign: "center" }}>
              <input
                type="radio"
                name={list.id_pernyataan}
                disabled={this.state.survei_disable}
                value="4"
                onChange={this.onChangeSurvei}
                checked={list.tingkat_kepuasan === 4}
              />
            </td>
          </tr>
        );
      });

      if (this.state.btn_hapus === true && this.state.survei_disable === false) {
        body_btn_hapus = (
          <Button
            disabled={this.state.loadingSaveSurvei}
            onClick={this.deleteSurvei}
            variant="danger"
            className="mr-2"
          >
            Hapus
            {this.state.loadingSaveSurvei && (
              <i className="ml-3 spinner spinner-white"></i>
            )}
            &nbsp;&nbsp;
          </Button>
        );
      }
    }

    let info_survei = "";
    if (this.state.info_survei === true) {
      info_survei = (
        <Alert variant="info">
          <b>
            Anda telah mengisi survei kepuasan pengguna aplikasi pelaporan SPMI
            (spmi.kemdikbud.go.id).
            <a
              href="#"
              onClick={this.lihatSurvei}
              className="btn btn-primary ml-2"
            >
              Lihat Disini
            </a>
          </b>
        </Alert>
      );
    }

    return (
      <>
        <style>{`
          .card-informasi {
            cursor: pointer;
            transition: transform 0.25s ease, box-shadow 0.25s ease;
          }
          .card-informasi:hover {
            transform: translateY(-6px);
            box-shadow: 0 12px 24px rgba(0,0,0,0.12) !important;
          }
        `}</style>
        {info_survei}
        {info_vokasi}
        <Card>
          {/* <CardContent> */}
          <form style={{ backgroundImage: `url(${bgImage2})` }}>
            {/* begin: Head */}
            <div
              style={{ backgroundImage: `url(${bgImage})` }}
              className="d-flex flex-column align-items-center justify-content-center pt-10 pb-10 bgi-size-cover bgi-no-repeat rounded-top"
            >
              <h2 className="text-white font-weight-bold font-size-1">
                SISTEM PENJAMINAN MUTU INTERNAL
              </h2>
              <span className="text-white font-weight btn-font-md mt-1">
                Pantauan Data Siklus PPEPP SPMI
              </span>
              <div className="mt-4">
                <YearSelect
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    border: "none",
                    minWidth: "100px"
                  }}
                />
              </div>
            </div>
            {/* end: Head */}

            <div className="row row-paddingless">
              <div className="col-4">
                <NavLink
                  to="/dashboard"
                  className="d-block py-17 px-5 text-center bg-hover-light border-right border-left border-bottom border-top"
                >
                  {this.state.dashboard === "Sudah Melengkapi"
                    ? sudah_melengkapi
                    : this.state.dashboard === "Belum Lengkap"
                      ? belum_lengkap
                      : this.state.dashboard === "Kosong"
                        ? kosong
                        : ""}
                  <span className="svg-icon svg-icon-3x svg-icon-success">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Shopping/Chart-bar2.svg"
                      )}
                    ></SVG>
                  </span>
                  <span className="d-block text-dark-75 font-weight-bold font-size-h6 mt-2 mb-1">
                    Dashboard
                  </span>
                  <span className="d-block text-dark-50 font-size-lg">
                    IPEPA BAN-PT
                  </span>
                </NavLink>
              </div>
              <div className="col-4">
                <NavLink
                  to="/penetapan/pengaturan-komitmen-mutu"
                  className="d-block py-17 px-5 text-center bg-hover-light border-right border-bottom border-top border-left"
                >
                  {this.state.penetapan === "Sudah Melengkapi"
                    ? sudah_melengkapi
                    : this.state.penetapan === "Belum Lengkap"
                      ? belum_lengkap
                      : this.state.penetapan === "Kosong"
                        ? kosong
                        : ""}
                  <span className="svg-icon svg-icon-3x svg-icon-success">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/Home/Building.svg")}
                    />
                  </span>
                  <span className="d-block text-dark-75 font-weight-bold font-size-h6 mt-2 mb-1">
                    Penetepan
                  </span>
                  <span className="d-block text-dark-50 font-size-lg">
                    Jumlah Pengaturan terisi : {this.state.penetapan_sudah_terisi > 0 ? <span className="text-success">{this.state.penetapan_sudah_terisi}</span> : <span className="text-danger">0</span>}
                  </span>
                </NavLink>
              </div>
              <div className="col-4">
                <NavLink
                  to="/pelaksanaan"
                  className="d-block py-17 px-5 text-center bg-hover-light border-right border-bottom border-top border-left"
                >
                  {this.state.pelaksanaan === "Sudah Melengkapi"
                    ? sudah_melengkapi
                    : this.state.pelaksanaan === "Belum Lengkap"
                      ? belum_lengkap
                      : this.state.pelaksanaan === "Kosong"
                        ? kosong
                        : ""}
                  <span className="svg-icon svg-icon-3x svg-icon-success">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/Home/Book-open.svg")}
                    ></SVG>
                  </span>
                  <span className="d-block text-dark-75 font-weight-bold font-size-h6 mt-2 mb-1">
                    Pelaksanaan
                  </span>
                  <span className="d-block text-dark-50 font-size-lg">
                    Standar Pendidikan Tinggi
                  </span>
                </NavLink>
              </div>

              <div className="col-4">
                <NavLink
                  to="/evaluasi"
                  className="d-block py-17 px-5 text-center bg-hover-light border-right border-top border-left border-bottom"
                >
                  {this.state.evaluasi === "Sudah Melengkapi"
                    ? sudah_melengkapi
                    : this.state.evaluasi === "Belum Lengkap"
                      ? belum_lengkap
                      : this.state.evaluasi === "Kosong"
                        ? kosong
                        : ""}
                  <span className="svg-icon svg-icon-3x svg-icon-success">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Communication/Clipboard-list.svg"
                      )}
                    ></SVG>
                  </span>
                  <span className="d-block text-dark-75 font-weight-bold font-size-h6 mt-2 mb-1">
                    Evaluasi
                  </span>
                  <span className="d-block text-dark-50 font-size-lg">
                    Jumlah Evaluasi terisi : {this.state.evaluasi_sudah_terisi > 0 ? <span className="text-success">{this.state.evaluasi_sudah_terisi}</span> : <span className="text-danger">0</span>}
                  </span>
                </NavLink>
              </div>

              <div className="col-4">
                <NavLink
                  to="/pengendalian"
                  className="d-block py-17 px-5 text-center bg-hover-light border-bottom border-left border-right border-top"
                >
                  {this.state.pengendalian === "Sudah Melengkapi"
                    ? sudah_melengkapi
                    : this.state.pengendalian === "Belum Lengkap"
                      ? belum_lengkap
                      : this.state.pengendalian === "Kosong"
                        ? kosong
                        : ""}
                  <span className="svg-icon svg-icon-3x svg-icon-success">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/Media/Repeat.svg")}
                    ></SVG>
                  </span>
                  <span className="d-block text-dark-75 font-weight-bold font-size-h6 mt-2 mb-1">
                    Pengendalian
                  </span>
                  <span className="d-block text-dark-50 font-size-lg">
                    Jumlah Pengendalian terisi : {this.state.pengendalian_sudah_terisi > 0 ? <span className="text-success">{this.state.pengendalian_sudah_terisi}</span> : <span className="text-danger">0</span>}
                  </span>
                </NavLink>
              </div>

              <div className="col-4">
                <NavLink
                  to="/peningkatan"
                  className="d-block py-17 px-5 text-center bg-hover-light border-right border-left border-bottom border-top"
                >
                  {this.state.peningkatan === "Sudah Melengkapi"
                    ? sudah_melengkapi
                    : this.state.peningkatan === "Belum Lengkap"
                      ? belum_lengkap
                      : this.state.peningkatan === "Kosong"
                        ? kosong
                        : ""}
                  <span className="svg-icon svg-icon-3x svg-icon-success">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/Home/Stairs.svg")}
                    ></SVG>
                  </span>
                  <span className="d-block text-dark-75 font-weight-bold font-size-h6 mt-2 mb-1">
                    Peningkatan
                  </span>
                  <span className="d-block text-dark-50 font-size-lg">
                    Jumlah Peningkatan terisi : {this.state.peningkatan_sudah_terisi > 0 ? <span className="text-success">{this.state.peningkatan_sudah_terisi}</span> : <span className="text-danger">0</span>}
                  </span>
                </NavLink>
              </div>
            </div>
          </form>
          {/* </CardContent> */}
        </Card>
        <Card className="mt-20">
          {/* <CardContent> */}
          {/* begin: Head */}
          <NoticeInformasi style={{ marginBottom: "0px", boxShadow: "none" }}>
            <strong style={{ fontSize: "18px" }}>Papan Informasi</strong>
            <br />
            <NavLink to="/informasi">
              <span className="text-dark">Selengkapnya..</span>
            </NavLink>
          </NoticeInformasi>
          {/* end: Head */}

          <div className="row mt-4 px-5">
            {this.state.loadingList === true ? (
              <div className="col-12">
                <Card>
                  <Card.Body>
                    <LinearProgress color="secondary" variant="query" />
                  </Card.Body>
                </Card>
              </div>
            ) : arrOfKonten.length > 0 ? (
              arrOfKonten.map((data, idx) => (
                <div
                  key={data.id_konten}
                  className="col-sm-6 col-md-4 col-lg-3 mb-4"
                >
                  <Card
                    className="h-100 shadow-sm card-informasi"
                    onClick={() => this.modalDetail(data.id_konten, coverPict[idx])}
                  >
                    <div
                      style={{
                        height: "200px",
                        overflow: "hidden",
                        backgroundColor: "#f8f9fa",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {coverPict[idx] ? (
                        <Card.Img
                          variant="top"
                          src={`data:image/jpeg;base64,${coverPict[idx]}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <img
                          src="media\\logos\\logo-letter-2.png"
                          alt="placeholder"
                          style={{
                            maxHeight: "120px",
                            maxWidth: "120px",
                            opacity: 0.5,
                          }}
                        />
                      )}
                    </div>
                    <Card.Body className="d-flex flex-column">
                      <Card.Title
                        className="font-weight-bold text-dark"
                        style={{
                          fontSize: "1rem",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      >
                        {data.judul}
                      </Card.Title>
                      <Card.Text
                        className="text-dark-50"
                        style={{
                          fontSize: "0.875rem",
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          flex: "1 0 auto",
                        }}
                      >
                        {data.deskripsi}
                      </Card.Text>
                      <div className="text-muted" style={{ fontSize: "0.8rem" }}>
                        <i className="flaticon-user mr-1" />
                        {data.nm_updater}
                        <br />
                        <i className="flaticon-calendar mr-1" />
                        {Moment(data.updated_at).format("DD-MMMM-YYYY")}
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              ))
            ) : (
              <div className="col-12">
                <Card>
                  <Card.Body>
                    <em className="text-muted">Belum ada informasi tersedia</em>
                  </Card.Body>
                </Card>
              </div>
            )}
          </div>
          {/* </CardContent> */}
        </Card>

        {/*========================================== Begin Modal Detail ========================================== */}
        <Modal
          size="lg"
          show={this.state.modalDetail}
          onHide={this.handleClose}
          keyboard={true}
          centered
        >
          <Modal.Header>
            <Modal.Title>
              {this.state.loadingDetails
                ? "Memuat..."
                : this.state.detail_informasi.judul}
            </Modal.Title>
            <button
              type="button"
              className="close"
              onClick={this.handleClose}
              style={{ outline: "none" }}
            >
              <i className="flaticon2-cross" />
            </button>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingDetails === true ? (
              <LinearProgress color="secondary" variant="query" />
            ) : (
              <>
                {this.state.detail_cover && (
                  <div
                    className="text-center mb-4"
                    style={{
                      maxHeight: "300px",
                      overflow: "hidden",
                      borderRadius: "6px",
                      backgroundColor: "#f8f9fa",
                    }}
                  >
                    <img
                      src={`data:image/jpeg;base64,${this.state.detail_cover}`}
                      alt="cover"
                      style={{
                        width: "100%",
                        height: "auto",
                        maxHeight: "300px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                )}
                <div
                  className="text-justify"
                  style={{ lineHeight: 1.8 }}
                  dangerouslySetInnerHTML={{
                    __html: this.state.detail_informasi.isi_konten,
                  }}
                />
                <hr />
                <div>
                  <strong>Lampiran :</strong>{" "}
                  {this.state.nm_file === undefined ? (
                    <i style={{ fontSize: "13px" }}>Tidak ada lampiran</i>
                  ) : (
                    <a
                      href="#"
                      onClick={() => this.downloadPDF(this.state.file)}
                      style={{ fontWeight: 500 }}
                    >
                      <i className="flaticon2-pdf-file mr-1" />
                      {this.state.nm_file}
                    </a>
                  )}
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>
        {/*========================================== End Modal Detail ========================================== */}
        <Modal size="xl" show={this.state.showSurvei}>
          <Modal.Header closeButton>
            <Modal.Title>
              Survei Kepuasan Pengguna Aplikasi Pelaporan SPMI
              (spmi.kemdikbud.go.id)
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table responsive style={{ overflow: "auto" }}>
              <thead
                className="text-white"
                style={{ backgroundColor: "#3047ad" }}
              >
                <tr>
                  <th style={{ textAlign: "center", width: "50%" }} rowSpan={2}>
                    Pernyataan
                  </th>
                  <th style={{ textAlign: "center", width: "30%" }} colSpan={4}>
                    Tingkat Kepuasan
                  </th>
                </tr>
                <tr>
                  <th style={{ textAlign: "center" }}>
                    STS{" "}
                    <Tooltip title="Sangat Tidak Setuju" placement="top">
                      <i
                        style={{ fontSize: "15px" }}
                        className="text-white fa fa-info-circle"
                      ></i>
                    </Tooltip>
                  </th>
                  <th style={{ textAlign: "center" }}>
                    TS{" "}
                    <Tooltip title="Tidak Setuju" placement="top">
                      <i
                        style={{ fontSize: "15px" }}
                        className="text-white fa fa-info-circle"
                      ></i>
                    </Tooltip>
                  </th>
                  <th style={{ textAlign: "center" }}>
                    S{" "}
                    <Tooltip title="Setuju" placement="top">
                      <i
                        style={{ fontSize: "15px" }}
                        className="text-white fa fa-info-circle"
                      ></i>
                    </Tooltip>
                  </th>
                  <th style={{ textAlign: "center" }}>
                    SS{" "}
                    <Tooltip title="Sangat Setuju" placement="top">
                      <i
                        style={{ fontSize: "15px" }}
                        className="text-white fa fa-info-circle"
                      ></i>
                    </Tooltip>
                  </th>
                </tr>
              </thead>

              <tbody>{data_survei}</tbody>
            </Table>
            <p>Masukan dan Saran bagi pengembangan aplikasi pelaporan SPMI :</p>
            <textarea
              className="resize-none"
              style={{ padding: "12px", width: "100%" }}
              disabled={this.state.survei_disable}
              size="lg"
              rows="4"
              placeholder="Ketikan saran Anda disini..."
              name="saran"
              value={this.state.saran}
              onChange={(e) => this.onChangeVal(e, "saran")}
            ></textarea>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              {body_btn_hapus}
              {this.state.survei_disable === false ? (
                <Button
                  disabled={this.state.loadingSaveSurvei}
                  variant="primary"
                  onClick={this.submitSurvei}
                >
                  Submit
                  {this.state.loadingSaveSurvei && (
                    <i className="ml-3 spinner spinner-white"></i>
                  )}
                  &nbsp;&nbsp;
                </Button>
              ) : (
                ""
              )}
            </div>
            <Button variant="secondary" onClick={this.handleCloseSurvei}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
export default ManajemenPenjaminanMutu;
